var _rect, _rect2, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackofficeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    stroke: "currentColor",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -0.707107,
    width: 3.85558,
    height: 3.85558,
    rx: 0.5,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 2.93359 12.7929)",
    stroke: "inherit",
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -0.5,
    width: 3.90517,
    height: 3.90517,
    rx: 0.5,
    transform: "matrix(1 0 0 -1 0.980469 3.90512)",
    stroke: "inherit",
    fill: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 1.95259,
    transform: "matrix(1 0 0 -1 11.3276 10.5265)",
    stroke: "inherit",
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.43359 4.56184V7.87499M6.23437 10.5269H9.18403",
    stroke: "inherit",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackofficeIcon);
export default __webpack_public_path__ + "static/media/backoffice_icon.a782ae79.svg";
export { ForwardRef as ReactComponent };